import { Component, type ErrorInfo, type ReactNode } from "react";

// Catches render-time errors anywhere below it so a crash shows a recoverable
// fallback instead of a blank white screen (the whole app unmounting). Inline-styled
// so it renders even if the app's own CSS is what broke. Cloned per app — Oriora apps
// have no shared package. (Standard since 2026-06-29.)
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("[oriora] render error", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "14px", padding: "32px", textAlign: "center", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", background: "#ffffff", color: "#18181b" }}>
        <div style={{ fontSize: "34px" }}>⚠️</div>
        <h1 style={{ fontSize: "18px", margin: 0, fontWeight: 600 }}>Something went wrong</h1>
        <p style={{ fontSize: "14px", color: "#71717a", maxWidth: "360px", lineHeight: 1.5, margin: 0 }}>
          This screen hit an unexpected error. Reloading usually fixes it — your data is safe.
        </p>
        <button onClick={() => window.location.reload()} style={{ marginTop: "6px", padding: "10px 20px", fontSize: "14px", fontWeight: 600, color: "#ffffff", background: "#7c3aed", border: "none", borderRadius: "10px", cursor: "pointer" }}>
          Reload
        </button>
      </div>
    );
  }
}
